<div class="detail-card">
  <div class="type-row">

    <div class="type-container">
      <img class="type-icon" alt="type" #type
        fiTranslation="{{leadTypeTranslation}}"
        matTooltip="{{ type.textContent }}" matTooltipPosition="below" matTooltipClass='tooltip-style'
        [src]="leadTypeIconUrl">
        <div class="type">{{ selectedLeadDetails?.Lead?.LeadTypeText }}</div>
      </div>

      @if (!contactToDisplay?.Anonymized && (canEditHeaderData || canShareWithFinstral)) {
        <button class="edit-btn" (click)="onEditLead()">
          <img src="assets/icons/pencil.svg" alt="Edit" #edit [isTitle]="true"
            fiTranslation="ALT_TEXT_REQUEST_LIST_EDIT" matTooltip="{{edit.dataset.matTooltip}}"
            matTooltipPosition="below" matTooltipClass='tooltip-style'>
          </button>
        }
      </div>

      <div class="type-row-date">
        <div class="date">{{ selectedLeadDetails?.Lead?.DateFormattedId }}</div>
        @if (selectedLeadDetails?.Lead?.Number) {
          <fi-copy-clipboard [small]="true" [copyText]="selectedLeadDetails?.Lead?.Number"></fi-copy-clipboard>
        }
      </div>

      <div class="create-tag-btn-container">

        <div class="title" fiTranslation="REQUEST_DETAIL_HEADER_TAGS_LABEL"></div>
        <div class="create-tag-btn-container-inner">
          @if (!tags?.length && userId === selectedLeadDetails?.Editor?.Id && canEdit) {
            <button (click)="openTagsDialog()"
              class="create-tag-btn">
              <mat-icon class="plus">add</mat-icon><span fiTranslation="REQUEST_DETAIL_HEADER_TAGS_ACTION_ADD_TAG"></span>
            </button>
          }

          @for (tag of tags; track tag; let i = $index) {
            <div class="tag">
              <span>{{ tag.Text }}</span>
              @if (tag.Owned) {
                <mat-icon (click)="deleteTag(tag)">close</mat-icon>
              }
            </div>
          }

          @if (tags?.length && userId === selectedLeadDetails?.Editor?.Id && canEdit) {
            <button class="add-btn"
              (click)="openTagsDialog()">
              <mat-icon>add</mat-icon><span fiTranslation="REQUEST_DETAIL_HEADER_TAGS_ACTION_ADD_TAG"></span>
            </button>
          }
        </div>
      </div>

      @if (leadTypeRelationshipManagement !== selectedLeadDetails?.Lead.LeadTypeId) {
        <div class="contact-row">
          <div>
            <div class="title" fiTranslation="ALT_TEXT_CONTACT_DETAIL_BUILDING_ADDRESS"></div>
            <a class="icon-text address-link" href="javascript:void(0)" (click)="openMapNewTab()">
              <img class="smaller" src="assets/icons/helmet-check.svg" alt="link">
              <span class="is-html-snippet" [innerHTML]="addressToDisplay"></span>
            </a>
          </div>
          @if (selectedLeadDetails?.Lead?.ConstructionTypeId && constructionTypes && selectedLeadDetails?.Lead?.LeadTypeId === leadOfferType) {
            <div>
              <div class="title" fiTranslation="GENERAL_TEXT_CONSTRUCTION_TYPE"></div>
              <div class="icon-text">
                <img class="construction-type" [src]="constructionIconUrl" alt="link">
                <span>{{ consultationTypeName }}</span>
              </div>
            </div>
            <div class="planer-composition">
              <div class="title" fiTranslation="GENERAL_TEXT_PLANER_KOMPOSITION"></div>
              <div class="icon-text">
                <div class="code-text">N°</div>
                <span class="cdk-visually-hidden" #planerCodeLink
                fiTranslation="REQUEST_DETAIL_HEADER_PLANNER_COMPOSITION_URL"></span>
                @if (extendedProperties?.PLANER_CODE) {
                  <a target="_blank"
                  href="{{planerCodeLink.innerText}}{{extendedProperties?.PLANER_CODE}}">{{ extendedProperties?.PLANER_CODE }}</a>
                }
                @if (!extendedProperties?.PLANER_CODE) {
                  <span>_____</span>
                }
              </div>
            </div>
          }
        </div>
      }

      @if (selectedLeadDetails?.ConnectedContacts?.length) {
        <div class="contact-row linked">
          <div>
            <div class="title"
            [fiTranslation]="selectedLinkedContactId ? 'GENERAL_TEXT_OWNER_ENQUIRY' : 'REQUEST_OVERVIEW_COLUMNS_HEADLINE_CONTACT_LINK'"></div>
          </div>
          <div class="linked-buttons">
            @if (selectedLinkedContactId) {
              <button (click)="openContactDetails(null)">
                <img src="assets/icons/user.svg" alt="user">
                {{ this.selectedLeadDetails?.Contact.FirstName }} {{ this.selectedLeadDetails?.Contact.LastName }}
              </button>
            }
            @if (!selectedLinkedContactId) {
              @for (contact of selectedLeadDetails?.ConnectedContacts; track contact) {
                <div class="linked-contact">
                  <button (click)="openContactDetails(contact.Id)">
                    <img src="assets/icons/user.svg" alt="user">
                    {{ contact.FirstName }} {{ contact.LastName }}
                  </button>
                  @if (canEdit && userId === selectedLeadDetails?.Editor?.Id) {
                    <mat-icon
                    (click)="disconnectContact(contact)">close</mat-icon>
                  }
                </div>
              }
            }
          </div>
        </div>
      }

      <div class="status-row">
        <div>
          <div class="status-title" fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_STATUS"></div>
          {{ selectedLeadDetails?.Lead?.StatusText }}
        </div>

        <div>
          <div class="status-title" fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_DUE_DATE"></div>
          <fi-lead-status
            class="status-box"
            [leadData]="selectedLeadDetails"
            [compactView]="true"
            [showStatusLabel]="false">
          </fi-lead-status>
        </div>
      </div>

      @if (showSharedLeadBox) {
        <fi-alert tone="info" (click)="onSharedBoxClick($event)">
          <span [hasHTMLTags]="true" fiTranslation="REQUEST_DETAIL_HEADER_ADD_TAG_INFOTEXT_SHARED_ENQUIRY"></span>
        </fi-alert>
      }
    </div>

